import { createContext } from 'react';

export const MachineryStatusContext = createContext(null);